import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, PageEvent } from '@angular/material';
import { FaixaFreteService } from 'src/app/services/faixa-frete.service';
import { CadastrarFaixaFreteModalComponent } from '../cadastrar-faixa-frete-modal/cadastrar-faixa-frete-modal.component';
import { FreteFaixa } from 'src/app/models/frete-faixa';
import swal from 'sweetalert2';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PaginatorService } from 'src/app/services/paginator.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-faixa-frete-modal',
  templateUrl: './faixa-frete-modal.component.html',
  styleUrls: ['./faixa-frete-modal.component.scss']
})
export class FaixaFreteModalComponent implements OnInit {
  faixas: FreteFaixa[];

  campoOrdenacao = 'de';
  ordenarDesc = false;
  filtroDescricao = '';
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;

  ultimaFaixa: FreteFaixa;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialog: MatDialog,
    private faixaFreteService: FaixaFreteService,
    private dialogRef: MatDialogRef<FaixaFreteModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
    
    this.buscarFaixas();
    this.buscarUltimaFaixaCadastrada();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFaixas();
  }

  filtra() {
    this.buscarFaixas();
    this.paginator.firstPage();
  }

  buscarFaixas() {
    this.carregandoService.mostra('buscarFaixas');

    this.faixaFreteService.consultarComPaginacao(
      this.filtroDescricao,
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc',
    )
      .subscribe(
        (dados) => {
          this.faixas = dados.itens;
          if (
            this.itensPorPagina >
            this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]
          ) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;

          this.buscarUltimaFaixaCadastrada();

          this.carregandoService.esconde('buscarFaixas');
        },
        (erro) => {
          this.carregandoService.esconde('buscarFaixas');
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarUltimaFaixaCadastrada() {
    this.carregandoService.mostra('buscarFaixas');

    this.faixaFreteService.consultarUltimaFaixa()
      .subscribe(
        (dados) => {
          this.ultimaFaixa = dados;

          this.carregandoService.esconde('buscarFaixas');
        },
        (erro) => {
          this.carregandoService.esconde('buscarFaixas');
          this.ultimaFaixa = new FreteFaixa();
          this.ultimaFaixa.de = 0;
          this.ultimaFaixa.ate = 0;
        }
      );
  }

  novaFaixa() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarFaixaFreteModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { item: new FreteFaixa(), ultimaFaixa: this.ultimaFaixa, itens: this.faixas },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: FreteFaixa) => {
      if (result) {
        this.validarSalvar(result);
      }
    });
  }

  editarFaixa(item: FreteFaixa) {
    const itemParaEditar = new FreteFaixa();

    Object.assign(itemParaEditar, item);

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarFaixaFreteModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { item: itemParaEditar, itens: this.faixas.filter(p => p !== item) },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: FreteFaixa) => {
      if (result) {
        this.validarSalvar(result);
      }
    });
  }

  validarSalvar(item: FreteFaixa) {
    if (Number(item.de) > Number(item.ate)) {
      swal({
        title: 'O valor inicial deve ser menor do que o desconto final!',
        text: '',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    } else if (this.faixas.some(p => (
      (Number(item.de) <= Number(p.de) && Number(item.ate) >= Number(p.de) && Number(item.ate) <= Number(p.ate)) ||
      (Number(item.de) <= Number(p.de) && Number(item.ate) >= Number(p.ate)) ||
      (Number(item.de) >= Number(p.de) && Number(item.de) <= Number(p.ate) && Number(item.ate) <= Number(p.ate)) ||
      (Number(item.de) >= Number(p.de) && Number(item.de) <= Number(p.ate) && Number(item.ate) >= Number(p.ate))))) {
      swal({
        title: 'Já existem valores dentro da mesma faixa de frete!',
        text: 'Deseja substituí-los?',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false,
        type: 'warning'
      }).then((result) => {
        if (result.value) {
          const existentes = this.faixas.filter(p => (
            (Number(item.de) <= Number(p.de) && Number(item.ate) >= Number(p.de) && Number(item.ate) <= Number(p.ate)) ||
            (Number(item.de) <= Number(p.de) && Number(item.ate) >= Number(p.ate)) ||
            (Number(item.de) >= Number(p.de) && Number(item.de) <= Number(p.ate) && Number(item.ate) <= Number(p.ate)) ||
            (Number(item.de) >= Number(p.de) && Number(item.de) <= Number(p.ate) && Number(item.ate) >= Number(p.ate))));

          existentes.forEach(p => {
            this.carregandoService.mostra('excluir');
            this.faixaFreteService.excluir(p.id).subscribe(
              () => {
                this.carregandoService.esconde('excluir');
                this.salvar(item);
              },
              err => {
                this.carregandoService.esconde('excluir');
                this.notificacaoService.erro(err);
              }
            );
          });
        }
      });
    } else {
      this.salvar(item);
    }
  }

  salvar(item: FreteFaixa) {
    item.de = Number(item.de);
    item.ate = Number(item.ate);

    this.carregandoService.mostra('salvar');
    this.faixaFreteService.salvar(item).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Faixa adicionada com sucesso!!!');
        this.buscarFaixas();
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  excluirFaixa(item: FreteFaixa) {
    swal({
      title: 'Deseja realmente Excluir a Faixa ' + 'de R$ ' + item.de.toFixed(2) + ' até R$ ' + item.ate.toFixed(2) + ' ?',
      text: '',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluir');
        this.faixaFreteService.excluir(item.id).subscribe(
          () => {
            this.carregandoService.esconde('excluir');
            this.notificacaoService.sucesso('Faixa excluída com sucesso!!!');
            this.buscarFaixas();
          },
          err => {
            this.carregandoService.esconde('excluir');
            this.notificacaoService.erro(err);
          }
        );
      }
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
